var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "ModalContainer",
    {
      attrs: {
        size: _vm.size,
        modalId: _vm.modalId,
        contentClass: _vm.contentClass,
        portal_class: _vm.portal_class,
      },
      on: { close: _vm.onClose },
    },
    [
      _vm._t("default", function () {
        return [
          _vm._t("header", function () {
            return [
              _vm.renderTitle
                ? _c(
                    "ModalHeader",
                    {
                      attrs: {
                        title: _vm.title,
                        showCustomTitle: _vm.showCustomTitle,
                        fullWidth: _vm.showCustomTitle,
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "flex",
                          class: _vm.modalHeaderSlotClasses,
                        },
                        [
                          _vm._t("titleLine"),
                          _c(
                            "button",
                            {
                              staticClass:
                                "ml-2 text-gray-400 hover:text-gray-500 focus:text-gray-500 focus:outline-none",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("close")
                                },
                              },
                            },
                            [_c("CrossIcon", { staticClass: "h-5 w-5" })],
                            1
                          ),
                        ],
                        2
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          }),
          _c(
            "div",
            { staticClass: "px-2" },
            [
              _vm._t("content", function () {
                return [
                  _c(
                    "form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.$emit("submit")
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex flex-col" },
                        [_vm._t("form")],
                        2
                      ),
                      _c(
                        "div",
                        { staticClass: "flex", class: _vm.actionClass },
                        [_vm._t("actions")],
                        2
                      ),
                    ]
                  ),
                ]
              }),
            ],
            2
          ),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }